import { useMemo } from "react";

interface UseEstimatedSharesProps {
  isNotional: boolean;
  quantity: number | undefined;
  midPrice: number;
  lastQuotePrice: number;
}

export const getEstimatedShares = ({
  isNotional,
  quantity,
  midPrice,
  lastQuotePrice,
}: UseEstimatedSharesProps) => {
  if (isNotional) {
    return quantity && midPrice > 0
      ? (quantity / midPrice)?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: lastQuotePrice < 1.0 ? 4 : 2,
        })
      : "-";
  }

  return quantity?.toLocaleString("en-US", {
    minimumFractionDigits: 2,
  });
};

export const useEstimatedShares = ({
  isNotional,
  quantity,
  midPrice,
  lastQuotePrice,
}: UseEstimatedSharesProps) => {
  const estimatedShares = useMemo(
    () =>
      getEstimatedShares({
        isNotional,
        quantity,
        midPrice,
        lastQuotePrice,
      }),
    [midPrice, quantity, lastQuotePrice, isNotional],
  );

  return { estimatedShares };
};
